module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoR.85ba110.ttf";